import React from 'react';
import UseGetDashBoardData from '../../../../../Components/Hooks/useDashboardData';
import { ModernStatWidget } from '../../Components/DashboardCard';
import NuAmount from '../../../../../Components/Utils/NuAmount';

function Stock() {
  const { data } = UseGetDashBoardData(`/dashboard/all-stocks`);

  const StockIcon = (
    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
    </svg>
  );

  return (
    <ModernStatWidget
      title="Total Stock Value"
      value={data?.stock_value ? Number(data.stock_value).toFixed(2) : "0.00"}
      subValue={data?.total_stocks ? <NuAmount currency={data?.currency} value={data?.total_stocks} /> : null}
      icon={StockIcon}
      bgColor="bg-emerald-500/10"
      iconColor="text-emerald-600"
    />
  );
}

export default Stock;